export enum EProductionSteps {
	PLANNED_MEALS = 'meals',
	INTERMEDIATES = 'semi_products',
	POSITIONS = 'positions',
	SCHEDULE = 'schedule',
	PACKAGING_EFFICIENCY = 'packaging_efficiency',
	PACKAGING_SCHEDULE = 'packaging_schedule',
}

export const productionSteps = [
	EProductionSteps.PLANNED_MEALS,
	EProductionSteps.INTERMEDIATES,
	EProductionSteps.POSITIONS,
	EProductionSteps.SCHEDULE,
	EProductionSteps.PACKAGING_EFFICIENCY,
	EProductionSteps.PACKAGING_SCHEDULE,
]

export const productionStepsMap: { [key in EProductionSteps]: string } = {
	[EProductionSteps.PLANNED_MEALS]: 'Planowane posiłki',
	[EProductionSteps.INTERMEDIATES]: 'Półprodukty',
	[EProductionSteps.POSITIONS]: 'Stanowiska robocze',
	[EProductionSteps.SCHEDULE]: 'Harmonogram produkcji',
	[EProductionSteps.PACKAGING_EFFICIENCY]: 'Wydajność',
	[EProductionSteps.PACKAGING_SCHEDULE]: 'Harmonogram pakowania',
}
